import Api from '@/plugin/Api';
import { RubricService, RubricDto, ActivityTypeService, ActivityTypeDTO, StaffRoleTypeEnum } from '@/generated/api.clients';
import { ref, onMounted, Ref, reactive, computed } from "@vue/composition-api";

export function useRubrics(): any {

    const loaded = ref(false)
    const api = new RubricService(undefined, Api);
    const rubrics: Ref<Array<RubricDto>> = ref(new Array<RubricDto>())

    const loadRubrics = async (): Promise<void> => {
        rubrics.value = [...await  api.getAllRubrics()]
        loaded.value = true
    }

    const activeRubrics = computed(() => {
        return rubrics.value.filter((r) => r.activeVersionId)
    })

    onMounted(loadRubrics)

    return reactive({
        rubricsLoaded: computed(() => loaded),
        rubrics: {
            all: rubrics,
            active: activeRubrics,
            forRole: (roleTypeId: StaffRoleTypeEnum) => {
                return rubrics.value.find(r => r.targetStaff?.includes(roleTypeId))
            }
        }
    })
}

export function useActivityTypes(): any {

    const loaded = ref(false)
    const api = new ActivityTypeService(undefined, Api);
    const activityTypes: Ref<Array<ActivityTypeDTO>> = ref(new Array<ActivityTypeDTO>())

    const load = async (): Promise<void> => {
        activityTypes.value = [...await  api.getActivityTypes()]
        loaded.value = true
        //console.log('loaded activity types', loaded.value)
    }

    onMounted(load)

    return reactive({
        loaded: computed(() => loaded),
        activityTypes: activityTypes
    })
}

export function useGoalPrompts(): any {
    return {}
}

export function useRoles(): any {
    const roles = [
        { value: 1, text: 'Superintendent' },
        { value: 2, text: 'Assistant Superintendent'},
        { value: 3, text: 'Principal' },
        { value: 4, text: 'Assistant Principal' },
        { value: 5, text: 'Gifted Educator' },
        { value: 6, text: 'Library / Media Specialist' },
        { value: 7, text: 'Speech and Language Pathologist' },
        { value: 8, text: 'Instructional Facilitator' },
        { value: 9, text: 'Guidance Counselor' },
        { value: 10, text: 'School Psychologist' },        
        { value: 11, text: 'Teacher' },
        { value: 100, text: 'Administrator/Other' },
        { value: 101, text: 'Curriculum Supervisor - K-12' },
        { value: 102, text: 'Curriculum Supervisor - Secondary' },
        { value: 103, text: 'Curriculum Supervisor - Elementary' },
        { value: 104, text: 'Special Education Supervisor' },
        { value: 105, text: 'Gifted/Talented Supervisor' },
        { value: 106, text: 'Career and Tech. Ed. Admin' },
        { value: 107, text: 'Content Area Spec. Program Admin' },
        { value: 108, text: 'Supervisor' },
        { value: 109, text: 'Business/Finance Administrator' },
        { value: 110, text: 'Director of Federal Programs' },
        { value: 111, text: 'Athletic Director' },
        { value: 112, text: 'Technology Coordinator' },
        { value: 113, text: 'Dean of Students' },
        { value: 114, text: 'Aspiring Teacher' },
        { value: 115, text: 'Aspiring Guidance Counselor' },
        { value: 116, text: 'Aspiring Media Specialist' },
        { value: 117, text: 'Licensed Pre-K Teacher' },
    ]

    roles.sort((a, b) => (a.text < b.text ? -1 : a.text > b.text ? 1 : 0))
    
    return {
        roles: roles,
        roleByValue: (value) => roles.filter(r=>r.value == value).length ? roles.filter(r=>r.value == value)[0] : null
    }
}

export function useLearnerStatus(): any {
    const statuses = [
        { value: 0, text: 'Not Set' },
        { value: 1, text: 'Novice Year 1' },
        { value: 2, text: 'Novice Year 2'},
        { value: 3, text: 'Novice Year 3' },
        { value: 4, text: 'Summative Year' },
        { value: 5, text: 'Formative Year 1' },
        { value: 6, text: 'Formative Year 2' },
        { value: 7, text: 'Formative Year 3' },
    ];

    return {
        statuses,
        statusByValue: (value) => statuses.find(r=>r.value == value)
    }
}

export function useScienceOfReadingStatus(): any {
    const statuses = [
        { value: 0, text: 'N/A' },
        { value: 1, text: 'Proficient' },
        { value: 2, text: 'Awareness'},
        { value: 3, text: 'Proficient/Awareness' }
    ];

    return {
        statuses,
        statusByValue: (value) => statuses.find(r=>r.value == value)
    }
}

export function useScienceOfReadingUpdateSource(): any {
    const statuses = [
        { value: 0, text: 'N/A' },
        { value: 1, text: 'AELS' },
        { value: 2, text: 'SIS'},
        { value: 3, text: 'AELS' } //Actually is EPP but is displayed as AELS for user convenience 
    ];

    return {
        statuses,
        statusByValue: (value) => statuses.find(r=>r.value == value)
    }
}

export function useTimes(): any {
  const start = 7, end = 19;
  const times: {label: string, value: {h: string, mm: string, A:string}}[] = [];
  let A = 'AM';
  for(let h = start; h < end; h++){
    for(let mm = 0; mm < 60; mm+=5){
      times.push({label: `${h%12==0?'12':h%12}:${ mm==5?'05': mm==0?'00' :mm } ${A}`, value: {h: (h%12==0?'12':h%12).toString(), mm: `0${mm.toString()}`.slice(-2), A}})
    }
    if(h == 11) A = 'PM'
  }
  times.push({label:`${end%12==0?'12':end%12}:00 ${end < 11 ? 'AM':'PM'}`, value: {h: (end%12).toString(), mm: "00", A: (end < 11) ? 'AM':'PM' }});
  return times;
}